import { customFetch } from '../../../shared/customFetch';
import { API_ROUTES } from '../../shared/ApiRoutes';

export const getBonds = () => {
  return customFetch.get(API_ROUTES.BOND.BASE);
};

export const getAvailableBonds = (userId: string) => {
  return customFetch.get(API_ROUTES.BOND.AVAILABLE(userId));
};

export const getBondOptions = () => {
  return customFetch.get(API_ROUTES.BOND.OPTIONS);
};

export const getUserOrders = (userId: string) => {
  return customFetch.get(API_ROUTES.OPERATION.ORDERS(userId));
};

export const getUserTransactions = (userId: string) => {
  return customFetch.get(API_ROUTES.OPERATION.TRANSACTIONS(userId));
};

export const getUserBonds = (userId: string) => {
  return customFetch.get(API_ROUTES.UTILISATEUR.BONDS(userId));
};

export const getUserVentes = (userId: string) => {
  return customFetch.get(API_ROUTES.OPERATION.VENTES(userId));
};

export const getBondMarket = (bondId: string) => {
  return customFetch.get(API_ROUTES.BOND.MARKET(bondId));
};

export const getBondBidAsk = (bondId: string) => {
  return customFetch.get(API_ROUTES.BOND.BIDASK(bondId));
};

export const getUsers = (userId: string) => {
  //return customFetch.get(API_ROUTES.UTILISATEUR.LISTE_AGENCE(userId));
  return customFetch.get(API_ROUTES.UTILISATEUR.BASE);
};

export const createOperation = (ope: any) => {
  return customFetch.post(API_ROUTES.OPERATION.OPERATION, ope);
};

export const getUserFavoris = (userId: string) => {
  return customFetch.get(API_ROUTES.FAVORIS.USER(userId));
};

export const createFavoris = (favoris: any) => {
  return customFetch.post(API_ROUTES.FAVORIS.BASE, favoris);
};

export const deleteFavoris = (favorisUrl: string) => {
  return customFetch.delete(favorisUrl);
};

export const getBondsAchat = () => {
  return customFetch.get(API_ROUTES.BOND.ACHAT);
};

export const getBondsVente = () => {
  return customFetch.get(API_ROUTES.BOND.VENTE);
};

export const getBondsTotalTransact = () => {
  return customFetch.get(API_ROUTES.BOND.TOTAL_TRANSACT);
};

export const getMovers = () => {
  return customFetch.get(API_ROUTES.BOND.MOVERS);
};

export const getPartners = () => {
  return customFetch.get(API_ROUTES.ADMIN.REPORTING);
};

export const getReporting = () => {
  return customFetch.get(API_ROUTES.ADMIN.REPORTINGBOND);
};

// asset managers
export const getAssetManagers = () => {
  return customFetch.get(API_ROUTES.ASSETMANAGER.BASE);
};

export const addAssetManager = (userId: string, asset: any) => {
  return customFetch.post(API_ROUTES.ASSETMANAGER.BASE, asset);
};

export const updateAssetManager = (
  userId: string,
  assetId: string,
  asset: any,
) => {
  return customFetch.put(API_ROUTES.ASSETMANAGER.UPDATE(assetId), asset);
};

export const deleteAssetManager = (userId: string, assetId: string) => {
  return customFetch.deletenon(API_ROUTES.ASSETMANAGER.DELETE(assetId));
};

//abonnement
export const addAbonnement = (userId: string, abon: any) => {
  return customFetch.post(API_ROUTES.ABONNEMENT.ADD(userId), abon);
};
export const listAbonnement = (userId: string, assetId: any) => {
  return customFetch.get(API_ROUTES.ABONNEMENT.LIST(userId, assetId));
};

// pack
export const getPack = () => {
  return customFetch.get(API_ROUTES.PACK.BASE);
};

export const addPack = (asset: any) => {
  return customFetch.post(API_ROUTES.PACK.BASE, asset);
};

export const updatePack = (packId: string, pack: any) => {
  return customFetch.put(API_ROUTES.PACK.UPDATE(packId), pack);
};

export const deletePack = (packId: string) => {
  return customFetch.deletenon(API_ROUTES.PACK.DELETE(packId));
};

//parameter
export const getParameter = (paramId: any) => {
  return customFetch.get(API_ROUTES.PARAMETER.GET(paramId));
};
export const updateParameter = (paramId: any, param) => {
  return customFetch.put(API_ROUTES.PARAMETER.UPDATE(paramId), param);
};

//chat
export const getConversations = (userId: string) => {
  return customFetch.get(API_ROUTES.TCHAT.BASE(userId));
};

export const findConversation = (userId: string, userId2: string) => {
  return customFetch.get(API_ROUTES.TCHAT.FIND(userId, userId2));
};

export const getSetUsers = (keyword: string) => {
  return customFetch.get(API_ROUTES.TCHAT.SEARCH(keyword));
};

export const addMessage = (mess: any) => {
  return customFetch.post(API_ROUTES.TCHAT.MESSAGE, mess);
};

//payement
export const createpayment = (userId: string, asset: any) => {
  return customFetch.post(API_ROUTES.PAY.BASE(userId), asset);
};

//payement
export const getSAdminReporting = () => {
  return customFetch.get(API_ROUTES.ADMIN.REPORTINSADMIN);
};

//forum
export const forumNetwork = {
  getHome: (userId: string) => {
    return customFetch.get(API_ROUTES.FORUM.BASE, { userId });
  },
  getTopic: (userId: string, topicId: string) => {
    return customFetch.get(API_ROUTES.FORUM.CATEGORY(topicId), { userId });
  },
  getPost: (userId: string, postId: string) => {
    return customFetch.get(API_ROUTES.FORUM.POST(postId), { userId });
  },
  postComment: (userId: string, postId: string, content: string) => {
    return customFetch.post(
      API_ROUTES.FORUM.ADDCOMMENT(userId),
      { content, post__id: postId },
      { userId },
    );
  },
  postTopic: (
    userId: string,
    description: string,
    topic: string,
    topicId?: string | undefined,
  ) => {
    return customFetch.post(
      API_ROUTES.FORUM.ADDFORUM(userId),
      { description, topic, topicId },
      { userId },
    );
  },
  postSubject: (
    userId: string,
    content: string,
    title: string,
    topicId: string,
  ) => {
    return customFetch.post(
      API_ROUTES.FORUM.ADDPOST(userId),
      { content, title, forum__id: topicId },
      { userId },
    );
  },
};
